<template>
  <div class="__v-oembed">
    <div class="__v-oembed-loading" :style="boxStyle" v-if="!resJson.provider_name && !errorMessage">Loading....</div>
    <div class="__v-oembed-error" :style="boxStyle" v-if="errorMessage">{{errorMessage}}</div>
  </div>
</template>

<script>

  import EndPoints from '../oembed/endpoints-regexp.json'
  import CustomEndPoints from '../oembed/custom-endpoints-regexp.json'

  //https://github.com/leonceaklin/oembed-component/tree/add-more-providers/src/components

export default {
  name: 'o-embed-2',
  props: {
    url: {
      type: String,
      required: true
    },
    proxy: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      resJson: Object,
      errorMessage: null,
      boxStyle: {
        fontFamily: '-apple-system, system-ui, Roboto, sans-serif',
        padding: '15px',
        border: '1px solid grey',
        color: 'grey',
        borderRadius: '3px',
        textAlign: 'center'
      }
    }
  },
  async mounted () {
    let matchedPattern = this.getOembedEnpoint(this.url)
    let matchedCustomElement = this.getCustomOembedEnpoint(this.url)
    if (matchedPattern) {
      matchedPattern = matchedPattern.replace('http://', 'https://')
      try {
        //var called = false;
        let res = await fetch(matchedPattern + '?url=' + this.url)
        this.resJson = await res.json()
        this.setInnerHtml(this.$el, '<div class="__v-oembed-content">' + this.resJson.html + '</div>')

        //this.$http.get(matchedPattern + '?url=' + this.url).then(response => {
        //  thisContext.resJson = response.data;
        //  thisContext.setInnerHtml(thisContext.$el, '<div class="__v-oembed-content">' + thisContext.resJson.html + '</div>')
        //});
      } catch (err) {
        this.errorMessage = 'Domain is not allowed'
      }
      
      /*
      try {
        matchedPattern = matchedPattern.replace('http://', 'https://')
        let res = await fetch(this.proxy + matchedPattern + '?url=' + this.url)
        this.resJson = await res.json()
        this.setInnerHtml(this.$el, '<div class="__v-oembed-content">' + this.resJson.html + '</div>')
      } catch (error) {
        this.errorMessage = 'Domain is not allowed'
      }
      */
    }
    else if (matchedCustomElement)
    {
      var html = matchedCustomElement.html.replace("$url", this.url);
      this.resJson = matchedCustomElement;
      //alert(this.$el)
      this.setInnerHtml(this.$el, '<div class="__v-oembed-content">' + html + '</div>')
    }
    else {
      

      this.errorMessage = 'Endpoint isn\'t supported'
    }
  },
  methods: {
    getOembedEnpoint: (url) => {
      return Object.keys(EndPoints).filter(endpoint => {
        let foundPattern = EndPoints[endpoint].filter(pattern => new RegExp(pattern).test(url))
        return foundPattern.length > 0
      })[0]
    },
    getCustomOembedEnpoint: (url) => {
      return CustomEndPoints.filter((endpoint) => {
        var pattern = new RegExp(endpoint.regex);
        return url.match(pattern);
      })[0]
    },
    setInnerHtml: (elm, html) => {
      elm.innerHTML = html
      /*
      Array.from(elm.querySelectorAll('script')).forEach(el => {
        let newEl = document.createElement('script')
        Array.from(el.attributes).forEach(el => {
          newEl.setAttribute(el.name, el.value)
        })
        newEl.appendChild(document.createTextNode(el.innerHTML))
        el.parentNode.replaceChild(newEl, el)
      })
      */
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/oembed/oembed.vue